import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FaCar } from "react-icons/fa";
import { Route, Router, Switch, useHistory, useRouteMatch } from "react-router-dom";
import flex from "../../styles/flex";
import usePaths from "../../utility/paths";
import { SessionContext } from "../../utility/useSession";
import DashPage from "../dash/DashPage";
import cssClasses from "./VehicleManager.module.css";
import { VehicleMovementsScanner } from "./vehicleMovements/VehicleMovementsScanner";

export const VehicleManager = () => {
  const session = useContext(SessionContext);
  const history = useHistory();
  const { path } = useRouteMatch();

  if (session.current.site == null) {
    return <></>;
  }

  return <DashPage>
    <Router history={history}>
      <Switch>
        <Route exact path={`${path}/move`} component={VehicleMovementsScanner} />
        <Route component={Menu} />
      </Switch>
    </Router>
  </DashPage>
}

const Menu = () => {
  const history = useHistory();
  const paths = usePaths();
  const { t } = useTranslation();

  return <Dialog
    open={true}
    onClose={() => history.push(paths.home)}
  >
    <DialogTitle>
      {t("vehicles.labels.vehicles")}
    </DialogTitle>
    <DialogContent>
      <div className={cssClasses.keyManagerDialog}>
        <Button
          onClick={() => history.push(paths.vehicleManagerMove)}
        >
          <div style={{ ...flex.flexColumns, marginTop: 20, marginBottom: 20 }}>
            <div>
              <FaCar size={40}></FaCar>
            </div>
            <div>
              <b>{t("booking.labels.moveVehicles")}</b>
            </div>
          </div>
        </Button>
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={() => history.push(paths.home)}>{t("general.cancel")}</Button>
    </DialogActions>
  </Dialog>
}
